import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
import { HPrepareReturnData } from "../helpers/HPrepareReturnData";

function useFetchLocationData() {
  // Función para buscar datos de ubicación por dirección o lugar
  const customerFetchSearch = async (search: string) => {
    // Evitar llamadas inválidas cuando no hay término de búsqueda
    if (!search || !search.trim()) {
      console.warn(
        "customerFetchSearch: búsqueda vacía; se omite llamada a Geocoding"
      );
      return undefined;
    }
    // const inputSearch = document.getElementById("customerSearch");
    // if (inputSearch) {
    //   inputSearch?.setAttribute("value", search);
    //   const event = new CustomEvent("updateSearch", {
    //     detail: search
    //   });
    //   window.dispatchEvent(event);
    // }

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          search
        )}&key=${ENVIRONMENT_VAR.MAP_KEY}&language=es-419&region=DO&components=country:DO`
      );
      const data = await response.json();
      // console.debug("Geocode address result:", data);
      if (data.status === "OK" && data.results.length > 0) {
        const locationInfo = data.results[0];
        return HPrepareReturnData(locationInfo);
      } else {
        throw new Error("No location data found for the given search term");
      }
    } catch (error) {
      console.error("Error in customer search:", error);
      return undefined;
    }
  };

  // Función para obtener datos de ubicación por coordenadas (latitud y longitud)
  const fetchLocationData = async (lat: number, lng: number) => {
    // Validar coordenadas antes de invocar la API
    if (
      typeof lat !== "number" ||
      typeof lng !== "number" ||
      Number.isNaN(lat) ||
      Number.isNaN(lng) ||
      !Number.isFinite(lat) ||
      !Number.isFinite(lng)
    ) {
      console.warn(
        "fetchLocationData: coordenadas inválidas; se omite llamada a Geocoding",
        { lat, lng }
      );
      return undefined;
    }
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${ENVIRONMENT_VAR.MAP_KEY}&language=es-419&region=DO`
      );
      const data = await response.json();
      if (data.status === "OK" && data.results.length > 0) {
        const locationInfo = data.results[0];

        return HPrepareReturnData(locationInfo);
      } else {
        throw new Error("No location data found");
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
      return undefined;
    }
  };

  return {
    fetchLocationData,
    customerFetchSearch
  };
}

export default useFetchLocationData;
